module.exports = __webpack_public_path__ + "static/img/百世.230ebe1a.png";